import { cn } from '@bem-react/classname';

export const cnSkeleton = cn('Skeleton');
